/**
 * @fileoverview 상대방이 보낸 메시지를 읽음 상태로 처리할 때 사용합니다.
 * 이 함수는 우선 메시지를 읽음 상태로 처리하고, 그 다음 reconcileChannelThunk를 통해 읽음 상태 처리를 한 채널과 unreadCount를 서버와 동기화 합니다.
 */
import { MarkAsReadRequest } from "@daangn/idl/rocketchat/api/api";
import { isNil } from "lodash";
import { store } from "~/rocketchat/redux/store";
import { sendRocketchatRequestWithPromise } from "~/rocketchat/rocketChatClient";
import { channelSelectors } from "../channelSlice";
import { markAsReadMessageThunk } from "../thunks/markAsReadMessageThunk";
import { createReconcileChannelThunk } from "../thunks/reconcileChannelThunk";

type MarkAsReadMessageParams = {
  channelId: string;
  messageId: string;
};

export const markAsReadMessage = async (
  { channelId, messageId }: MarkAsReadMessageParams,
  socket: WebSocket,
) => {
  const response = await sendRocketchatRequestWithPromise({
    socket,
    chatRequest: {
      name: "MarkAsReadRequest",
      mark_as_read: MarkAsReadRequest.create({
        channel_id: channelId,
        message_id: messageId,
      }),
    },
  });

  const markAsReadMessageResponse = response.mark_as_read;

  if (isNil(markAsReadMessageResponse)) {
    throw new Error("markAsReadMessageResponse is nil");
  }

  store.dispatch(
    markAsReadMessageThunk({
      unreadCount: markAsReadMessageResponse.unread_count,
    }),
  );

  const currentChannel = channelSelectors.selectById(
    store.getState().channel,
    channelId,
  );

  if (isNil(currentChannel)) {
    throw new Error(`markAsReadMessage: Channel not found: ${channelId}`);
  }

  const reconcileChannelThunk =
    createReconcileChannelThunk("markAsReadMessage");
  store.dispatch(
    reconcileChannelThunk({
      channelId,
      criteriaMessageId: currentChannel.last_message_id,
    }),
  );
};
